// packages/keyboard-management/src/stores/sdkStore.ts
import { create } from "zustand";

interface SdkStore {
  sdkApi: any | null;
  setSdkApi: (sdkApi: any) => void;
}

export const useSdkStore = create<SdkStore>((set) => ({
  sdkApi: null,
  setSdkApi: (sdkApi) => {
    set({ sdkApi });
  },
}));

// ✅ 导出便捷 hooks
export const useSdkApi = () => useSdkStore((state) => state.sdkApi);
export const useSetSdkApi = () => useSdkStore((state) => state.setSdkApi);
